<template>
  <div class="wrap">
    <div class="content">
      <div class="formContent EC_width">
        <div class="flex1 display_center_ud">
          <div>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-left: 100px">
          <login-vue></login-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginVue from '../../components/login.vue'
export default {
  name: 'index',
  components: { loginVue }
}
</script>

<style scoped>
/* 每套全部引入 */
/* 每套页面对应的公共样式,每套页面都会引用 */
/*biaoji*/
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

input {
  height: 40px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  outline: none;
  padding-left: 12px;
}

.title {
  font-size: 110px;
  color: #fff;
  position: relative;
}

.title:before {
  content: "";
  display: inline-block;
  width: 60px;
  height: 5px;
  background: #ffffff;
  border-radius: 2px;
  position: absolute;
  top: -5px;
}

.titleSub {
  font-size: 40px;
  color: #fff;
  margin-bottom: 20px;
}

.english {
  font-size: 16px;
  color: #ffffff;
}

.english:after {
  content: "————";
  margin-left: 10px;
}

.english img {
  vertical-align: middle;
  margin-right: 10px;
}

.width100 {
  width: 100%;
}

.headBar {
  height: 60px;
}

.headBarRight a {
  margin-right: 30px;
}

.headBarRight a img {
  margin-right: 8px;
}

.content {
  background: url("../../assets/img/loginbg3.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 70%;
  height: calc(100vh - 0px);
  padding: 0 15%;
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
}

.formContent {
  display: flex;
  flex: 1;
}

.formBlock {
  background: #fff;
  width: 340px;
  padding-top: 40px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 36px;
  border-radius: 30px 0 30px 0;
  box-sizing: border-box;
  position: relative;
}

.bianjiao {
  position: absolute;
  right: 0;
  top: 0;
}

.bianjiaobtn {
  position: absolute;
  right: 40px;
  top: 13px;
  color: #0b8686;
  font-size: 12px;
  width: 76px;
  height: 22px;
  box-sizing: border-box;
  padding-left: 10px;
  line-height: 22px;
  background: url("../../assets/img/login/bianjaiobtn.png");
}

.login_title {
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  margin-bottom: 30px;
}

.login_title span {
  display: inline-block;
  padding: 0 14px;
  padding-bottom: 10px;
  font-weight: bold;
  color: #0b8686;
  border-bottom: 2px solid #0b8686;
}

.login_title a {
  display: inline-block;
  padding: 0 14px;
  padding-bottom: 10px;
  font-weight: bold;
}

.login_title_active {
  color: #0b8686;
  border-bottom: 2px solid #0b8686;
}

.inputBar {
  display: flex;
  margin-bottom: 20px;
}

.btnNormal {
  display: inline-block;
  height: 40px;
  text-align: center;
  line-height: 40px;
  width: 104px;
  background: #e1e1e1;
}

.btnSubmit {
  width: 100%;
  height: 40px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  color: #fff;
  background: #0b8686;
}

.footer {
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
}

.beian {
  color: #fff;
}

.footer a {
  color: #fff;
  margin-left: 30px;
}

/* 登录2 */
.successTip {
  height: 240px;
  flex-direction: column;
}

.successTipText {
  font-size: 22px;
  color: #0b8686;
  line-height: 1.6em;
}

.Erro {
  border: 1px solid red;
}

.flex1 {
  display: flex;
  align-items: center;
}
</style>
